import { Box } from '@mui/material';
import styled, { keyframes } from 'styled-components';

export const NavigationContainer = styled(Box)`
  padding: ${({ theme }) => theme.spacing[4]};
  width: 100%;
  height: 100vh;
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  border-right: 1px solid ${({ theme }) => theme.colors.border};
  overflow-y: auto;
  flex-shrink: 0;
  transition: width ${({ theme }) => theme.duration.fast} ${({ theme }) => theme.easing.easeOut};

  @media (min-width: 768px) and (max-width: 1199px) {
    padding: ${({ theme }) => theme.spacing[2]};
    align-items: center;
  }
`;

export const NavSection = styled(Box)`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing[2]};
`;

export const NavSectionLabel = styled.div`
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: 0.6875rem;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: ${({ theme }) => theme.colors.textMuted};
  padding: ${({ theme }) => theme.spacing[2]} ${({ theme }) => theme.spacing[3]};
  margin-bottom: ${({ theme }) => theme.spacing[1]};

  @media (min-width: 768px) and (max-width: 1199px) {
    display: none;
  }
`;

const slideIndicator = keyframes`
  from {
    opacity: 0;
    transform: scaleY(0);
  }
  to {
    opacity: 1;
    transform: scaleY(1);
  }
`;

export const ActiveIndicator = styled.div`
  position: absolute;
  left: 0;
  top: ${({ theme }) => theme.spacing[1]};
  bottom: ${({ theme }) => theme.spacing[1]};
  width: 3px;
  border-radius: ${({ theme }) => theme.radii.full};
  background-color: ${({ theme }) => theme.colors.primary};
  animation: ${slideIndicator} ${({ theme }) => theme.duration.fast} ${({ theme }) => theme.easing.spring};
`;

export const NavItemWrapper = styled(Box)`
  position: relative;
  width: 100%;
`;

export const UserSectionContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: ${({ theme }) => theme.spacing[3]};
  border-top: 1px solid ${({ theme }) => theme.colors.border};
`;
